import { Spinner } from 'src/components/Spinner/Spinner';
import styled from 'styled-components';

export const SpinnerFullWidth = styled(Spinner)`
    margin: 0 auto;
    display: block;
`;
